import { Message } from '@agently/types';
import { createMutation, createSuspenseQuery } from 'react-query-kit';

import { api } from './client';

export const useMarkMessageAsRead = createMutation({
  mutationFn: ({ messageId }: { messageId: number }) =>
    api.post(`/messenger/messages/${messageId}/read`),
});

export const useGetMessages = createSuspenseQuery({
  fetcher: async () => {
    const { data } = await api.get<{ messages: Message[] }>(
      '/messenger/messages',
    );
    return data.messages;
  },
  queryKey: ['messenger', 'messages'],
});

export const useGetUnreadMessages = createSuspenseQuery({
  fetcher: async () => {
    const { data } = await api.get<{ messages: Message[] }>(
      '/messenger/messages/unread',
    );
    return data.messages;
  },
  queryKey: ['messenger', 'messages', 'unread'],
  refetchOnWindowFocus: false,
});
